import React from "react";

export default function FormLabel({ children }) {
  return (
    <p className="text-gray-700 font-medium text-sm mt-4 mr-0 mb-1 ml-0 block">
      {children}
    </p>
  );
}
